import React, { Component } from 'react'

class SleepDisorder extends Component {
    render() {
        const disorders = [
            {
                img: "Snoring.png",
                title: "Snoring",
                desc: "Regular and loud snoring may indicate an underlying disorder."
            },
            {
                img: "Sleeplessness.png",
                title: "Sleeplessness",
                desc: "Also known as Insomnia, it saps your energy and keeps your attention level 'low.'"
            },
            {
                img: "Obesity.png",
                title: "Obesity",
                desc: "An unexpected weight gain may occur with sleep deprivation or poor sleeping habits."
            },
            {
                img: "Breathlessness.png",
                title: "Breathlessness",
                desc: "Shortness of breath is observed in people having very poor sleep hygiene."
            },
            {
                img: "Fatigue.png",
                title: "Fatigue",
                desc: "A lack of energy or zero interest in daily activities has been associated with poor sleep quality."
            },
            {
                img: "ConsistentNight.png",
                title: "Night Awakenings",
                desc: "Bad sleep habits, stress, anxiety, depression, sleep apnea or other reasons could be behind repeated night awakenings."
            },
            {
                img: "PersistentInability.png",
                title: "Chronic Insomnia",
                desc: "Chronic Insomnia that stress, anxiety, poor sleep habits, work pressure or other factors could cause."
            },
            {
                img: "DaytimeSleepiness.png",
                title: "Daytime Sleepiness",
                desc: "A person may feel sleepy despite getting adequate sleep due to changed circadian rhythms, sleep apnea, narcolepsy, etc."
            },
            {
                img: "RestlessLeg.png",
                title: "Restless Legs Syndrome",
                desc: "Repeated leg movement may happen at night due to sleep issues reported by parents or partners."
            }
        ];

        return (
            <section className="brand-logo-wrapper section-padding vSleepDisorderBlock">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2>Sleep Disorder Symptoms</h2>
                        </div>
                    </div>
                    <div className="row sleep-disorder-grid">
                        {disorders.map((item, index) => (
                            <div className="col-lg-4 col-md-6 col-12" key={index}>
                                <div className='sleepdisorder'>
                                    <img src={require(`../assets/img/whatsinaname/sleepdisorder/${item.img}`)} alt={item.title} />
                                    <h3>{item.title}</h3>
                                    <p>{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        )
    }
}

export default SleepDisorder
